import { render, staticRenderFns } from "./admin_user.vue?vue&type=template&id=3bb6039c&scoped=true&"
import script from "./admin_user.vue?vue&type=script&lang=js&"
export * from "./admin_user.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bb6039c",
  null
  
)

export default component.exports